import streleSvg from "@/assets/strele_s.svg";

const BrandBackground = () => (
  <div
    className="pointer-events-none fixed inset-0 z-0"
    aria-hidden="true"
  >
    <img
      src={streleSvg}
      alt=""
      className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120vw] max-w-none opacity-[0.14]"
    />
  </div>
);

export default BrandBackground;
